import { render, staticRenderFns } from "./CRUDEventProcessIndex.vue?vue&type=template&id=7485d585"
import script from "./CRUDEventProcessIndex.vue?vue&type=script&lang=js"
export * from "./CRUDEventProcessIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports